import React from 'react';
import { HelpCircle } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface StepFAQData {
  faq_topics: string;
}

interface StepFAQProps {
  data: StepFAQData;
  onChange: (data: StepFAQData) => void;
}

export function StepFAQ({ data, onChange }: StepFAQProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <HelpCircle className="w-4 h-4" />
          Welke vragen krijg jij het vaakst van klanten?
        </label>
        <textarea
          value={data.faq_topics}
          onChange={(e) => onChange({ ...data, faq_topics: e.target.value })}
          rows={6}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Klanten vragen me vaak: hoe lang duurt het voordat ik resultaat zie? Wat kost het precies? Kan ik ook beginnen zonder ervaring? Ze lopen er tegenaan dat ze niet weten waar te beginnen en bang zijn voor de investering."
          autoFocus
        />
        <AnswerQualityHint length={data.faq_topics.length} />
        <p className="text-sm text-gray-500 mt-2">
          Waar lopen ze tegenaan vóórdat ze bij jou komen?
        </p>
      </div>
    </div>
  );
}
